// Shared vue-i18n instance.
// Exported so non-Vue helper modules (e.g. easy_cron/validator.js) can localize
// user-facing text via i18n.t(...) using the same locale/messages as the app.
import Vue from 'vue'
import VueI18n from 'vue-i18n' //引入vue-i18n组件

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'zh',
  messages: {
    'zh': require('./lang/zh.js'),   // 中文语言包
    'en': require('./lang/en.js')    // 英文语言包
  }
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/i18n.js